import * as Sentry from '@sentry/react'
import type { Middleware } from 'redux'

import type { RootState } from 'store'

import { getSelectedCompositionSaveData } from 'models/compositions/selectors'
import { STORED_COMPOSITION_LABEL } from 'models/localStorage/constants'
import { getHasLocalStoredComposition } from 'models/localStorage/selectors'

import * as types from 'models/actionTypes'


const localStorageMiddleware: Middleware<null, RootState> = (store) => (next) => (action) => {
    let nextAction = action
    switch (action.type) {
        case types.SAVE_SELECTED_COMPOSITION_TO_LOCAL_STORAGE: {
            const saveData = getSelectedCompositionSaveData(store.getState())
            try {
                window.localStorage.setItem(STORED_COMPOSITION_LABEL, JSON.stringify(saveData))
            } catch (error) {
                Sentry.captureException(error)
            }
            break
        }
        case types.LOAD_COMPOSITION_FROM_LOCAL_STORAGE: {
            try {
                if (getHasLocalStoredComposition()) {
                    const saveDataString = window.localStorage.getItem(STORED_COMPOSITION_LABEL)
                    if (saveDataString) {
                        const saveData = JSON.parse(saveDataString)
                        // Legacy difference in saving/loading
                        saveData.placedfurnitureSet = saveData.placedFurniture
                        nextAction = {
                            ...nextAction,
                            composition: saveData,
                        }
                    }
                }
            } catch (error) {
                Sentry.captureException(error)
            }
            break
        }
        default:
            break
    }
    return next(nextAction)
}

export default localStorageMiddleware
